import HotelImportModel from "./HotelImportModel";

export default class HotelsImportResultModel {
    public static Create(obj?: Partial<HotelsImportResultModel>) {
        return Object.assign(new HotelsImportResultModel(), obj ?? {}, {
            hotels: (obj?.hotels ?? []).map(x => HotelImportModel.Create(x)),
        })
    }

    isOk: boolean = true
    errorMessage: string = ''
    countSaved: number = 0
    countFailed: number = 0
    countDuplicates: number = 0
    hotels: HotelImportModel[] = []
}
